module.exports = __webpack_public_path__ + "images/3e80809cbe8b897652faaf02ba1f51c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-locations00.jpg
// module id = ./webpack/assets/img/wheels-locations00.jpg
// module chunks = 0